class ProductDetails extends Theme.Component {
  connectedCallback() {
    this.events();
  }

  showTab(_, element) {
    const index = element.dataset.index;
    const allContents = this.querySelectorAll('.product-details-content');
    const allTabs = this.querySelectorAll('.product-details-tab');
    allTabs.forEach(tab => tab.classList.toggle('is-active', tab.dataset.index === index));
    allContents.forEach(content => content.classList.toggle('is-active', content.dataset.index === index));
  }
}

customElements.define('product-details', ProductDetails);

